import { Country } from '@angular-material-extensions/select-country';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import {MdbTableDirective, MdbTablePaginationComponent} from 'angular-bootstrap-md';
import { FileLikeObject, FileUploader } from 'ng2-file-upload';
import { AdsService } from '../services/ads.service';
import { AppService } from '../../services/app.service';

// export interface Events {
//     adname: string;
//     image: string;
//     descritpion: string; 
//     url:string;
//     duration:string;
//     country:string;
//     status:string;

//   }
@Component({
  selector: 'app-ads',
  templateUrl: './ads.component.html',
  styleUrls: ['./ads.component.scss']
})
export class AdsComponent implements OnInit {

  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, {static: true}) mdbTable: MdbTableDirective;

  headElements = ['Ad Name', 'Image', 'Description','Redirection URL', 'Duration', 'Status', 'Action'];
  searchText: string = '';
  previous: string;
  countryFormControl = new FormControl();
  countryFormGroup: FormGroup;
  public uploader: FileUploader = new FileUploader({});
  adForm: FormGroup;
  stat
  active: string= "active"

  adsListUser:[] = []

  cancellationReason: boolean;
  cancellationArray:any = [];

 formData: FormData = new FormData();

  adsList:any = [];
  constructor(private cdRef: ChangeDetectorRef,
    private formBuilder: FormBuilder, private adsService: AdsService, private appService: AppService) {
  }

  @HostListener('input') oninput() {
      this.searchItems();
  }

  ngOnInit() {
    this.adForm = this.formBuilder.group({
      name: '',
      description: '',
      url: '',
      duration: '',
      // country: '',
      img: [null]
      // img: ''
    });
      
      // this.countryFormGroup = this.formBuilder.group({
      //   country: []
      // });
      // this.appService.getCountries().then((res: any) => {
      //   if (res.success) {
      //     for (let i = 0; i < res.countries.length; i++) {
      //       this.predefinedCountries.push({
      //         name: res.countries[i].countryname,
      //         alpha2Code: res.countries[i].code,
      //         alpha3Code: res.countries[i].countrycode,
      //         numericCode: res.countries[i].id
      //       })
          
      //     }
      //   }
      // })
      this.adsService.getAllAds("123").then((res: any) => {
      
        if (res.success) {
          console.log(res)
          for (let i = 0; i < res.ads.data.length; i++) {
           
          if(res.ads.data[i].status == 1){this.stat="active"} else if(res.ads.data[i].status == 0){this.stat="inactive"} 
            this.adsList.push({ 
              id: res.ads.data[i].id, 
              name: res.ads.data[i].name,
              image: res.ads.data[i].image,
              description: res.ads.data[i].description,
              url: res.ads.data[i].url,
              duration: res.ads.data[i].duration,
              status: this.stat,
             });
          }
          console.log(this.adsList)
          this.mdbTable.setDataSource(this.adsList);
      this.previous = this.mdbTable.getDataSource();
        }
      })
        .catch((error) => {
          console.log(error)
        })
  }

  predefinedCountries: Country[] = [];

  getFiles(): FileLikeObject[] {
    return this.uploader.queue.map((fileItem) => {
      return fileItem.file;
    });
  }
  url;
  msg = "";

  selectFile(event) {

    if (!event.target.files[0] || event.target.files[0].length == 0) {
      this.msg = 'You must select an image';
      return;
    }

    var mimeType = event.target.files[0].type;

    if (mimeType.match(/image\/*/) == null) {
      this.msg = "Only images are supported";
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.msg = "";
      this.url = reader.result;
    }

    const file = (event.target as HTMLInputElement).files[0];
    this.adForm.patchValue({
      img: file
    });

    this.adForm.get('img').updateValueAndValidity();
  }

  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(10);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }

  searchItems() {
      const prev = this.mdbTable.getDataSource();
      if (!this.searchText) {
          this.mdbTable.setDataSource(this.previous);
          this.adsList = this.mdbTable.getDataSource();
      }
      if (this.searchText) {
          this.adsList = this.mdbTable.searchLocalDataBy(this.searchText);
          this.mdbTable.setDataSource(prev);
      }
  }

  onCountrySelected($event: Country) {
    
    console.log($event.numericCode)
    this.formData.append("country", $event.numericCode);
    
  }
  createAd(){
    console.log("clicked")
    console.log( this.adForm.get('img').value)

    this.formData.append("name", this.adForm.get('name').value);
    this.formData.append("description", this.adForm.get('description').value);
    this.formData.append("url", this.adForm.get('url').value);
    this.formData.append("country", "123");
    this.formData.append("duration", this.adForm.get('duration').value);    
    this.formData.append("image", this.adForm.get('img').value);
        this.adsService.createAd(this.formData).then((res: any) => {   
          if(res.success){
          console.log(res)
          this.adForm.reset();
      this.url = "";
      this.msg = "";
        this.adsService.getAllAds("123").then((res: any) => {
      console.log(res)
      this.adsList = (res.ads.data);
      for (let i = 0; i < this.adsList.length; i++) {
        if (this.adsList[i].country == "123"){this.adsList[i].country = "Lebanon"}
      if(this.adsList[i].status == 1){this.adsList[i].status="active"} else if(this.adsList[i].status == 0){this.adsList[i].status="inactive"}
      }
      this.mdbTable.setDataSource(this.adsList);
this.previous = this.mdbTable.getDataSource();
})
  } else {
    alert(res.error);
  }
  })

}

activateId(id){
  console.log(id)
  this.adsService.activateAd(id).then((res: any) => {
    if(res.success){
    console.log(res)
    this.adsService.getAllAds("123").then((res: any) => {
      console.log(res)
      this.adsList = (res.ads.data);
      for (let i = 0; i < this.adsList.length; i++) {
        if (this.adsList[i].country == "123"){this.adsList[i].country = "Lebanon"}
      if(this.adsList[i].status == 1){this.adsList[i].status="active"} else if(this.adsList[i].status == 0){this.adsList[i].status="inactive"}
      }
      this.mdbTable.setDataSource(this.adsList);
this.previous = this.mdbTable.getDataSource();
})
    } else {
      console.log(res.error)
    }
  })
}

deleteId(){
  this.adsService.deleteAd(this.cancellationArray.id).then((res: any) => {
    if(res.success){
    console.log(res)
    this.adsService.getAllAds("123").then((res: any) => {
      console.log(res)
      this.adsList = (res.ads.data);
      for (let i = 0; i < this.adsList.length; i++) {
        if (this.adsList[i].country == "123"){this.adsList[i].country = "Lebanon"}
      if(this.adsList[i].status == 1){this.adsList[i].status="active"} else if(this.adsList[i].status == 0){this.adsList[i].status="inactive"}
      }
      this.mdbTable.setDataSource(this.adsList);
this.previous = this.mdbTable.getDataSource();
this.cancellationReason = false;
}) 
    } else {
      console.log(res.error);
    }
  })
}

saveAd(el){
  localStorage.setItem("adDetails", JSON.stringify(el))
}

showCancellation(id) {
  this.cancellationReason = true;
  this.cancellationArray.id = id;
  console.log(this.cancellationArray.id)

}

hideCancellation() {
  this.cancellationReason = false;
}
}